import React from 'react'
import PropTypes from 'prop-types'

const TableBody = ({ classes, children, innerRef = null, ...props }) => (
  <tbody {...props} ref={innerRef} className={classes}>
    {children}
  </tbody>
)

TableBody.propTypes = {
  children: PropTypes.node,
  classes: PropTypes.string,
  innerRef: PropTypes.string,
}

export default TableBody
